import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';

import { App } from './app/App';
import { StoreProvider } from './app/StoreProvider';
import { appPath } from './infrastructure/routing';
import './styles/global.css';

const app = (
  <StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </StrictMode>
);
const root = document.getElementById('root')!;

// only the homepage is prerendered, the other shells hydrate empty -- YOLO Achievements
if (root.hasChildNodes() && appPath() === '/') hydrateRoot(root, app);
else {
  root.replaceChildren();
  createRoot(root).render(app);
}

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    // no rush, register when the page is idle
    const register = () => navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`);
    if ('requestIdleCallback' in window) window.requestIdleCallback(() => void register());
    else globalThis.setTimeout(() => void register(), 1000);
  });
}
